import { atom, useRecoilValue } from 'recoil';

export interface DecodeToken {
  exp: number;
  iat: number;
  id: number;
  role: string;
  username: string;
}

/**
 * @deprecated useShopInfo 사용. 나중에 제거.
 */
export interface ShopAuthContextState {
  shopID: string;
}

/**
 * 선택된 샵 ID를 저장합니다.
 *
 * FIXME: jotai & persist 로 바꾸고, shopID 만 저장하도록 변경.
 *
 * @deprecated
 */
export const shopAuthContextState = atom<ShopAuthContextState>({
  key: 'shopAuthContext',
  default: {
    shopID: '',
  },
  effects: [
    ({ setSelf, onSet }) => {
      const key = 'shopState' as const;

      const savedValue = localStorage.getItem(key);
      if (savedValue != null) {
        setSelf(JSON.parse(savedValue));
      }

      onSet((newValue, _, isReset) => {
        isReset ? localStorage.removeItem(key) : localStorage.setItem(key, JSON.stringify(newValue));
      });
    },
  ],
});

/**
 * 저장된 Shop 권한을 가져옵니다.
 *
 * @deprecated useShopInfo 사용. 나중에 제거.
 */
export const useShopAuth = () => {
  return useRecoilValue(shopAuthContextState);
};
